import { ServerConfig } from "@/config/config";
import { AwsDocument, BankType, Car, Contact, ContactAddress, ContactExtraFields, ContactGroup, DiverseLedger, FrequencyDocument, Product, ProductCompositionRow, ProductExtraFields, ProductImage, ProductPriceCategorySalesDates, ProductStock, ProductTrackingNumber, ProductWriteOffRow, Purchase, Sale, SaleExtraFields, SaleRow, StockIn, Vat } from "@/models/base";
import { BankAwsFile } from "@/models/base/bank-aws-file";
import BankBalance from "@/models/base/bank-balance";
import { BankCtepSaleResult } from "@/models/base/bank-ctep-sale-result";
import { CarAwsDocument } from "@/models/base/car-aws-document";
import CarExtraFields from "@/models/base/car-extra-fields";
import { ClosedPeriod } from "@/models/base/closed-period";
import { ContactAwsDocument } from "@/models/base/contact-aws-document";
import { ContactPriceRule } from "@/models/base/contact-price-rule";
import { ContactStats } from "@/models/base/contact-stats";
import Currency from "@/models/base/currency";
import { DeletedPurchase } from "@/models/base/deleted-purchase";
import { DeletedSale } from "@/models/base/deleted-sale";
import { Deposit } from "@/models/base/deposit";
import { Fostplus } from "@/models/base/fostplus";
import { GeneralPriceRule } from "@/models/base/general-price-rule";
import { ProductGroupModel } from "@/models/base/product-group-model";
import { ProductGroupProduct } from "@/models/base/product-group-product";
import { ProductIntrastatData } from "@/models/base/product-intrastat-data";
import { ProductLabelSettings } from "@/models/base/product-label-settings";
import { ProductProfitRules } from "@/models/base/product-profit-rules";
import { ProductAwsDocument } from "@/models/base/product-aws-document";
import { Axios } from "@/utils/axios";
import { ProductSupplier } from "@/utils/product-supplier";
import { PurchaseAwsFile } from "@/models/base/purchase-aws-file";
import PurchaseExtraFields from "@/models/base/purchase-extra-fields";
import { PurchaseLedger } from "@/models/base/purchase-ledger";
import { SaleAwsDocument } from "@/models/base/sale-aws-document";
import SaleHistory from "@/components/sales/SaleHistory.vue";
import SaleRowExtraFields from "@/models/base/sale-row-extra-fields";
import SaleType from "@/views/settings/sale/SaleType.vue";
import { StockMovement } from "@/models/base/stock-movement";

export class ScriptServiceClass {
	private readonly url:string = `${ServerConfig.host}/scripts`;

	async runScript(scriptId:number, args:string[]):Promise<string>{
		let result = await Axios.post(`${this.url}/${scriptId}/run`, args);
		return result.data;
	}

	// eslint-disable-next-line max-lines-per-function
	public getBaseModelConstructors():{[key:string]:Function}{
		return {
			AwsDocument,
			BankAwsFile,
			BankBalance,
			BankCtepSaleResult,
			BankType,
			CarAwsDocument,
			CarExtraFields,
			Car,
			ClosedPeriod,
			Contact,
			ContactAddress,
			ContactGroup,
			ContactExtraFields,
			ContactAwsDocument,
			Currency,
			ContactStats,
			ContactPriceRule,
			DeletedPurchase,
			DeletedSale,
			Deposit,
			DiverseLedger,
			Fostplus,
			FrequencyDocument,
			GeneralPriceRule,
			Product,
			ProductSupplier,
			ProductExtraFields,
			ProductCompositionRow,
			ProductGroupModel,
			ProductGroupProduct,
			ProductImage,
			ProductIntrastatData,
			ProductLabelSettings,
			ProductPriceCategorySalesDates,
			ProductProfitRules,
			ProductStock,
			ProductTrackingNumber,
			ProductWriteOffRow,
			ProductAwsDocument,
			Purchase,
			PurchaseAwsFile,
			PurchaseExtraFields,
			PurchaseLedger,
			Sale,
			SaleRow,
			SaleAwsDocument,
			SaleHistory,
			SaleRowExtraFields,
			SaleType,
			SaleExtraFields,
			StockIn,
			StockMovement,
			Vat
		};
	}
}

export const ScriptService = new ScriptServiceClass();